export default {"src":"/_next/static/media/dots-dropdown-icon.67acc2e0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};